import React from "react";
import moment from 'moment'
import { WizTableForm } from '@/containers/common'

const cert = WizTableForm.Config.cert(this, { apiParams: { state: 1 } })
const user = WizTableForm.Config.user(this, { apiParams: {} })

//配置项
const componentName = "certReport";

function columns() {
  return [
    {
      title: "证书名称",
      name: "certId",
      searchItem: {
        ...cert,
        diy: WizTableForm,
        selectType: 'radio',
        rules: [
          {
            required: true,
            message: '请选择证书名称'
          }
        ]
      },
    },
    {
      title: "学员账号",
      name: "account",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "fullName",
      tableItem: {},
    },
    {
      title: "学员姓名",
      name: "personIds",
      searchItem: {
        ...user,
        diy: WizTableForm,
      },
    },
    {
      title: "学员身份证",
      name: "idCard",
      tableItem: {},
    },
    {
      title: "dp账号状态",
      name: "dpAvtiveStatusCn",
      tableItem: {},
    },
    {
      title: "dp人脸识别结果",
      name: "dpAuthenRecordCn",
      tableItem: {},
    },
    {
      title: "账号状态",
      name: "accountState",
      tableItem: {},
      searchItem: {
        type: 'select',
      },
      dict: [
        { code: 1, codeName: '启用' },
        { code: 0, codeName: '禁用' },
      ]
    },
    {
      title: "任职",
      name: "userIdentityInfos",
      tableItem: {
        type: 'popover'
      },
    },
    {
      title: "证书名称",
      name: "certName",
      tableItem: {},
    },
    {
      title: "证书分类",
      name: "category",
      tableItem: {},
    },
    // {
    //   title: "证书分类",
    //   name: "categoryId",
    //   dict: {
    //     wizReplaceData: "certCategoryNodeList"
    //   },
    //   searchItem: {
    //     type: 'treeselect'
    //   }
    // },
    {
      title: "证书类别",
      name: "type",
      tableItem: {},
      // searchItem: {
      //   type: 'select',
      // },
      dict: [
        { code: 1, codeName: '培训证书' },
        { code: 2, codeName: '社会证书' },
      ]
    },
    {
      title: "证书编号",
      name: "certCode",
      searchItem: {},
      tableItem: {},
    },
    {
      title: "获得时间",
      name: "certDate",
      searchItem: {
        type: 'date~',
        showTime: true,
      },
      tableItem: {},
    },
    {
      title: "最后更新时间",
      name: "updateTime",
      tableItem: {},
    },
    {
      title: "是否适用",
      name: "ifApply",
      tableItem: {},
      searchItem: {
        type: 'select',
      },
      dict: [
        { code: 1, codeName: '适用' },
        { code: 0, codeName: '不适用' },
      ]
    },
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          buttonSort:['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ],
          dataFormat: (v) => {
            let value = Object.assign([], v)
            if (value['certDate'] && value['certDate'].length === 2) {
              value['certDateStart'] = moment(value['certDate'][0]).format("YYYY-MM-DD HH:mm:00")
              value['certDateEnd'] = moment(value['certDate'][1]).format("YYYY-MM-DD HH:mm:59")
            }
            // delete value['certDate']

            return value
          }
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageListStudent`,
    payload: {
      key: `${componentName}@getPageListStudent`,
      apiParams: { pageNum: 1, pageSize: 10 },
    },
  },
  export: {
    path: `${componentName}/exportStudent`,
    payload: {
      key: `${componentName}@exportStudent`,
      apiParams: {}
    }
  },
  certCategoryNodeList: {
    path: `contentLabel/nodeList`,
    payload: {
      key: `contentLabel@nodeList`,
      apiParams: { state: 1, type: 1 }
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list", "certCategoryNodeList"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
